import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {SCREEN_SIZE, SearchType, ListingCategory} from '../../../classes/enums';
import {FiltersSearch} from './filters-search';
import { take } from 'rxjs/operators';
import {distinctUntilChanged, debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-filters-search',
  templateUrl: './filters-search.component.html',
  styleUrls: ['../filters.component.scss', '../filters.desktop.component.scss', 'filters-search.component.scss']
})
export class FiltersSearchComponent extends FiltersSearch implements OnInit {
  screenSize: SCREEN_SIZE;
  SCREEN_SIZE = SCREEN_SIZE;
  @ViewChild('formElementRef') formElementRef: ElementRef;
  @ViewChild('moreDropdownElement') moreDropdownRef: ElementRef;

  closeDropdowns(dropdownName?, newStatus?) {
    this.showMore = false;
    if (dropdownName) this[dropdownName] = newStatus;
  }

  @HostListener('window:click', ['$event'])
  onPageClick($event: MouseEvent) {
    if (!this.formElementRef.nativeElement.contains($event.target) || (this.moreDropdownRef && !this.moreDropdownRef.nativeElement.contains($event.target))) {
      this.closeDropdowns();
    }
  }

  ngOnInit() {
    super.ngOnInit();
    this.addSub(this.communicationService.screenSize.subscribe((screenSize) => {
      if (this.screenSize > SCREEN_SIZE.MOBILE_ONLY) {
        this.listenToFormChanges();
        this.fetchFilters();
      }
      else if (this.screenSize === SCREEN_SIZE.MOBILE_ONLY) {
        this.subscribeToFiltersChanges();
      }
    }));
    this.addSub(
      this.preferencesService.agentSearchFiltersChanged
        .pipe(distinctUntilChanged((a, b) => a.text !== b.text))
        .subscribe((filters) => {
        this.onFilterChange(filters);
    }));
  }

  protected fetchFilters() {
    if (this.isSubscribedToFilterChanges) return;
    else this.isSubscribedToFilterChanges = true;
    (this.searchType === SearchType.AGENT ?
      this.preferencesService.agentSearchFiltersChanged :
      this.preferencesService.officeSearchFiltersChanged
    ).pipe(take(1)).toPromise()
    .then((filters) => this.onFilterChange(filters));
  }
  private subscribeToFiltersChanges() {
    this.addSub((this.searchType === SearchType.AGENT ?
      this.preferencesService.agentSearchFiltersChanged :
      this.preferencesService.officeSearchFiltersChanged
    ).pipe(distinctUntilChanged(), debounceTime(100)).subscribe((filters) => {
      this.onFilterChange(filters);
    }));
  }

  private onFilterChange(filters) {
    if (this.currentShownListingType === ListingCategory.COMMERCIAL) {
      this._updateRealEstateFilterForPropertyType(filters, 'Commercial');
    }
    this.updateFilters(filters);
  }
}
